var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFreePricing = function SvgIconFreePricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-free-pricing_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#CCD1E0",
    rx: 18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEE1EB",
    d: "M32.845 86.48c26.47-23.82 24.123-70.868 19.642-91.415l-57.15 38.601C-3.19 61.196 6.375 110.3 32.844 86.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9DA3B5",
    d: "M41.213 23.28v2.44c0 .853-.4 1.653-1.093 2.147L25.453 38.613a2.66 2.66 0 0 1-3.173-.013l-1.92-1.44c-.867-.653-1.573-2.067-1.573-3.147V23.28c0-1.493 1.146-3.147 2.546-3.667l7.294-2.733c.76-.28 1.986-.28 2.746 0l7.294 2.733c1.4.52 2.546 2.174 2.546 3.667ZM39.093 30.453c.88-.64 2.12-.014 2.12 1.08v2.506c0 1.08-.706 2.48-1.573 3.134l-7.293 5.453c-.64.467-1.494.707-2.347.707s-1.707-.24-2.347-.72l-1.106-.827a1.33 1.33 0 0 1 .013-2.147l12.533-9.186Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-free-pricing_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#fff",
    rx: 18
  })))));
};
export default SvgIconFreePricing;